module.exports = __webpack_public_path__ + "static/media/icon-take-photo.936aeb8f.svg";